import cogoToast from 'cogo-toast';
import { takeLatest, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import {
  DOWNLOAD_MANUAL_BOOKING_SAMPLE_EXCEL,
  DOWNLOAD_MANUAL_BOOKING_SAMPLE_EXCEL_SUCCESS,
  DOWNLOAD_MANUAL_BOOKING_SAMPLE_EXCEL_ERROR,
} from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* downloadManualBookingSampleExcel({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    // Booking modification serves its sample from a different route, with the booking type in the path.
    const isBookingModification = payload.issueType === 'booking_modification';

    const response = yield call(apiCall, {
      url: isBookingModification
        ? `${adminAPIURL}/v2/utility-request/booking-modification/sample-excel/${payload.bookingType}`
        : `${adminAPIURL}/v2/utility-request/manual-booking-sample-excel`,
      method: 'GET',
      ...(isBookingModification ? {} : { params: { booking_type: payload.bookingType } }),
      headers: filteredHeaders,
      isOctetStream: true,
    });

    if (response.status === 200) {
      const blob = new Blob([response.data], {
        type: response.headers?.['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${isBookingModification ? 'booking_modification' : 'manual_booking'}_sample_${payload.bookingType || 'template'}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      yield put({ type: DOWNLOAD_MANUAL_BOOKING_SAMPLE_EXCEL_SUCCESS, payload: true });
    } else {
      cogoToast.error(response?.response?.data?.message || 'Download failed');
      yield put({ type: DOWNLOAD_MANUAL_BOOKING_SAMPLE_EXCEL_ERROR, payload: response?.response?.data?.message });
    }
  } catch (error) {
    cogoToast.error('Download failed');
    yield put({ type: DOWNLOAD_MANUAL_BOOKING_SAMPLE_EXCEL_ERROR, payload: error });
  }
}

export function* watchDownloadManualBookingSampleExcel() {
  yield takeLatest(DOWNLOAD_MANUAL_BOOKING_SAMPLE_EXCEL, downloadManualBookingSampleExcel);
}

function* downloadManualBookingSampleExcelSaga() {
  yield all([fork(watchDownloadManualBookingSampleExcel)]);
}

export default downloadManualBookingSampleExcelSaga;